import React, { useEffect, useContext }from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// ui components
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Check from "@material-ui/icons/Check";
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";

//services
import { MaskDate, formateDate, validateDate, convertDate, MaskCPF, MaskCEP, MaskRG, MaskCel} from "beaktShared/helpers/masks";
import { UseGetApiSimple, UseGetApiendPointDiferent } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

//styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function GestaoClienteForm({ addItem, item, handleView, loading }) {
    const { t } = useTranslation();
    const classes = useStyles();  
    const session = useContext(SessionContext);  
    const {register, handleSubmit, setValue,setError, errors, clearError, getValues  } = useForm({mode: "onBlur"});
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);

    const intialValues = {
        id:0,
        cpf:'',
        rg:'',
        nome:'',
        ativo:false,
        dataNascimento:'',
        email:'',
        celular:'',
        linkFacebook:'',
        linkInstagram:'',
        rua:'',
        numero:'',
        complemento:'',
        bairro:'',
        cidade:'',
        estado:'',
        cep:'',
        usuarioId: 0,
    };
   
    const [loadingValidateEmail, setloadingValidateEmail] = React.useState(false);
    const handleEmailChange = e =>{ 
        let email = e.target.value; 
        if(email==="")
            return;

        setloadingValidateEmail(true);
        const endPoint = "clientes/clientebyemail/"+email+"/"+session.estabelecimentoId;
        UseGetApiSimple(endPoint,0).then(result=>{       
            if(result.status === 200)
            {
                LoadDadosItem(result.data);
                setloadingValidateEmail(false);  
                return true;
            }  
            setloadingValidateEmail(false);                    
        }); 
    }
    
    const [loadingCep,setloadingCep] = React.useState(false);
    const handleCEPBlur = (e) =>{
        let cep = e.target.value; 
        if(cep==="")
            return;
        cep = cep.replace("-","");

        setloadingCep(true);
        const endPoint = "https://viacep.com.br/ws/"+cep+"/json";
        UseGetApiendPointDiferent(endPoint).then(result=>{       
            if(result.status !== 200)
            {                                     
                //showNotification(result.message,'danger');   
                setloadingCep(false); 
                return false; 
            } 
            let resultcep = result.data; 
            setValue('rua', resultcep.logradouro);
            setValue('complemento', resultcep.complemento);
            setValue('bairro', resultcep.bairro);
            setValue('cidade', resultcep.localidade);
            setValue('estado', resultcep.uf);
            setloadingCep(false);                    
        }); 
    };

    const [loadingValidateCPF, setloadingValidateCPF] = React.useState(false);
    const [validateCPF, setvalidateCPF] = React.useState(false);
    const handleCPFChange = e =>{ 
        let cpf = e.target.value; 
        if(cpf==="")
            return;
        if(cpf.length < 14)  
            return; 

        let data = getValues()
            
        setloadingValidateCPF(true);
        const endPoint = "clientes/vefifycpf/"+cpf+"/"+parseInt(data.id);
        UseGetApiSimple(endPoint,0).then(result=>{       
            if(result.status !== 200)
            {                                     
                //showNotification(result.message,'danger');   
                setloadingValidateCPF(false); 
                return false; 
            }  
            setvalidateCPF(result.data);
            if(result.data)
                setError("cpf", "invalidcpf", t('error_message.cpf_already_existing'))
            else
                clearError("cpf");
            setloadingValidateCPF(false);                    
        }); 
    }      

    const [sexo, setSexo] = React.useState("");

    const handleSexoChange = event => {
        setSexo(event.target.value);
        setValue("sexo", event.target.value);  
        if (event.target.value !== "") 
            clearError("sexo");   
    };

    useEffect(() => {        
        LoadDadosItem(item);
    // eslint-disable-next-line
    }, [item]);

    const LoadDadosItem =(item) =>{
        if(!item.clienteId)
            return;   

        setValue('id', item.clienteId);
        setValue('usuarioId', item.usuarioId);
        setValue('nome', item.nome);
        setAtivoCheckbox(item.ativo);
        setValue('cpf', item.cpf);
        setValue('rg', item.rg);

        var dtnasc = "";  
        if(item.dataNascimento!==null)
            dtnasc = formateDate(item.dataNascimento); 
        
        setValue('dataNascimento', dtnasc);
        if(item.sexo !== null)
        {            
            setSexo(item.sexo);
            setValue("sexo", item.sexo);
        }
        setValue('email', item.email);
        setValue('celular', item.celular);
        setValue('linkFacebook', item.linkFacebook);
        setValue('linkInstagram', item.linkInstagram);
        setValue('rua', item.rua);
        setValue('numero', item.numero);
        setValue('complemento', item.complemento);
        setValue('bairro', item.bairro);
        setValue('cidade', item.cidade);
        setValue('estado', item.estado);
        setValue('cep', item.cep); 
    }

    const onSubmit = (data, e) => {
       e.preventDefault();
        if (validateCPF) {
            return setError("cpf", "invalidcpf", t('error_message.cpf_already_existing2'))
        }        

        var dataNasC = "";
        if(data.dataNascimento!=="")
        {
            if (!validateDate(data.dataNascimento)) {
                return setError("dataNascimento", "invaliddate", t('error_message.invalid_date'))
            }            
            dataNasC = convertDate(data.dataNascimento);       
        }

        let sexoE = parseInt(data.sexo);
        if(isNaN(sexoE))
            sexoE  = null;

        var cliente = {
            clienteId:parseInt(data.id),
            nome:data.nome,
            ativo:data.ativo,
            cpf:data.cpf,
            rg:data.rg,
            dataNascimento:dataNasC,
            sexo: sexoE,
            email:data.email,
            celular:data.celular,
            linkFacebook:data.linkFacebook,
            linkInstagram:data.linkInstagram,
            rua:data.rua,
            numero:data.numero,
            bairro:data.bairro,
            complemento:data.complemento,
            cidade:data.cidade,
            estado:data.estado,
            cep:data.cep,
            usuarioCadastroId:session.id,
            usuarioId:parseInt(data.usuarioId)
        }
        //console.log(JSON.stringify(cliente));
        addItem(cliente);
    };
    
    const handleViewForm = () => {
        handleView(true);
    };


    return (
        <div className="maxContent">  
            <form onSubmit={handleSubmit(onSubmit)}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <PermIdentity />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                <small>{t('information_message.fill_in_your_details')} </small>
                                <input className={classes.hidden} defaultValue={intialValues.id} name="id" ref={register} />
                                <input className={classes.hidden} defaultValue={intialValues.usuarioId} name="usuarioId" ref={register} />
                            </h4>
                        </CardHeader>
                        <CardBody>                            
                            <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                            <div className="subTitulo"> 
                            <h6>{t('label.identification')} </h6>
                            </div>
                            </GridItem>   
                            <GridItem xs={12} sm={6} md={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            error={errors.email?true:false}
                                            label={t('label.email')}
                                            variant="outlined"
                                            inputRef={register({
                                                required: t('label.required'),
                                                pattern: {
                                                    value: /^\S+@\S+$/i,
                                                    message: t('label.invalid_email')
                                                },
                                                maxLength: {
                                                    value:50,
                                                    message: t('label.enter_a_maximum_of_50_characters')
                                                }
                                            })}
                                            name="email"
                                            defaultValue={intialValues.email}
                                            InputLabelProps={{shrink: true}}
                                            InputProps={{
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                    {loadingValidateEmail && <LoadingIcon className="rotate" />}
                                                </InputAdornment>
                                                ),
                                            }}
                                        />
                                         {errors.email &&<FormHelperText className={classes.labelRootError}>
                                            <span> {errors.email.message} </span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                             </GridContainer>
                             <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.nome?true:false}
                                        label={t('label.name')+" *"}
                                        variant="outlined"
                                        inputRef={register({required: true})}
                                        name="nome"
                                        defaultValue={intialValues.nome}
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 100}}  
                                    />
                                    {errors.nome && <FormHelperText className={classes.labelRootError}>
                                        <span>{t('label.required')} </span>
                                    </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                <FormControl fullWidth className={classes.formControl}>
                                    <TextField                                      
                                        error={errors.sexo?true:false}
                                        select
                                        variant="outlined"
                                        label={t('label.gender')}
                                        value={sexo}
                                        onChange={handleSexoChange}               
                                        name="sexo"
                                        ref={() =>register({ name: "sexo" })}
                                        InputLabelProps={{shrink: true}}  
                                       >
                                        <MenuItem value="0">
                                        {t('label.famale')}
                                        </MenuItem>
                                        <MenuItem value="1">
                                        {t('label.male')}
                                        </MenuItem>
                                    </TextField>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.dataNascimento?true:false}
                                        label={t('label.date_of_birth')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="dataNascimento"
                                        defaultValue={intialValues.dataNascimento}
                                        InputLabelProps={{shrink: true}}    
                                        InputProps={{
                                            inputComponent: MaskDate,
                                        }}                              
                                    />
                                    {errors.dataNascimento && <FormHelperText className={classes.labelRootError}>
                                        <span>{errors.dataNascimento.message} </span>
                                    </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                            </GridContainer>                   
                            <GridContainer>                         
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.cpf?true:false}
                                        label={t('label.cpf')}
                                        variant="outlined"
                                        onChange={handleCPFChange}
                                        inputRef={register({required: false})}
                                        name="cpf"
                                        defaultValue={intialValues.cpf}
                                        InputLabelProps={{shrink: true}}
                                        InputProps={{
                                            inputComponent: MaskCPF,
                                            endAdornment: (
                                            <InputAdornment position="end">
                                                {loadingValidateCPF && <LoadingIcon className="rotate" />}
                                            </InputAdornment>
                                            ),
                                        }}                           
                                    />
                                    {errors.cpf &&<FormHelperText className={classes.labelRootError}>
                                         <span>{errors.cpf.message} </span>
                                    </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.rg?true:false}
                                        label={t('label.rg')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="rg"
                                        defaultValue={intialValues.rg}
                                        InputLabelProps={{shrink: true}}
                                        InputProps={{
                                            inputComponent: MaskRG
                                        }}                          
                                    />
                                    {errors.rg &&<FormHelperText className={classes.labelRootError}>
                                         <span>{errors.rg.message} </span>
                                    </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={4}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                tabIndex={-1}                                                
                                                checked={ativoCheckbox}   
                                                onClick={event => {setAtivoCheckbox(event.target.checked)}}                                             
                                                checkedIcon={<Check className={classes.checkedIcon} />}
                                                icon={<Check className={classes.uncheckedIcon} />}
                                                classes={{
                                                    checked: classes.checked,
                                                    root: classes.checkRoot
                                                }}                    
                                                name="ativo"  
                                                inputRef={register}                                                    
                                            />
                                        }
                                        classes={{
                                            label: classes.label,
                                            root: classes.labelRoot
                                        }}
                                        label={t('information_message.system_active')+"?"}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Clearfix />
                            <GridContainer>                                 
                                <GridItem xs={12} sm={12} md={12}>
                                <div className="subTitulo"> 
                                <h6>{t('label.contact_data')} </h6>
                                </div>
                                </GridItem>                                 
                                <GridItem xs={12} sm={6} md={4}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.celular?true:false}
                                        label={t('label.cell_phone')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="celular"
                                        defaultValue={intialValues.celular}
                                        InputLabelProps={{shrink: true}}
                                        InputProps={{
                                            inputComponent: MaskCel,
                                        }} 
                                    />
                                    </FormControl>
                                </GridItem> 
                                <GridItem xs={12} sm={6} md={4}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.linkFacebook?true:false}
                                        label={t('label.facebook')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="linkFacebook"
                                        defaultValue={intialValues.linkFacebook}
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 50}}
                                    />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.linkInstagram?true:false}
                                        label={t('label.instagram')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="linkInstagram"
                                        defaultValue={intialValues.linkInstagram}
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 50}}
                                    />
                                    </FormControl>
                                </GridItem>
                            </GridContainer>
                            <Clearfix />
                            <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className="subTitulo"> 
                                <h6>{t('label.address_data')} </h6>
                                </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.cep?true:false}
                                        label={t('label.zip_code')}                        
                                        onBlur={handleCEPBlur} 
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="cep"
                                        defaultValue={intialValues.cep}
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 10}}
                                        InputProps={{
                                            inputComponent: MaskCEP,
                                            endAdornment: (
                                            <InputAdornment position="end">
                                                {loadingCep && <LoadingIcon className="rotate" />}
                                            </InputAdornment>
                                            ),
                                        }}  
                                    />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={7}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.rua?true:false}
                                        label={t('label.street')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="rua"
                                        defaultValue={intialValues.rua}
                                        InputLabelProps={{shrink: true}}                                   
                                        inputProps={{maxLength: 50}}
                                    />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={2}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.numero?true:false}
                                        label={t('label.number')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="numero"
                                        defaultValue={intialValues.numero}
                                        InputLabelProps={{shrink: true}}                                      
                                        inputProps={{maxLength: 8}}
                                    />
                                    </FormControl>
                                </GridItem>
                            </GridContainer>
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.complemento?true:false}
                                        label={t('label.complement')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="complemento"
                                        defaultValue={intialValues.complemento}
                                        InputLabelProps={{shrink: true}}                                        
                                        inputProps={{maxLength: 30}}
                                    />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.bairro?true:false}
                                        label={t('label.neighborhood')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="bairro"
                                        defaultValue={intialValues.bairro}
                                        InputLabelProps={{shrink: true}}                                        
                                        inputProps={{maxLength: 50}}
                                    />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.cidade?true:false}
                                        label={t('label.city')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="cidade"
                                        defaultValue={intialValues.cidade}
                                        InputLabelProps={{shrink: true}}                                        
                                        inputProps={{maxLength: 50}}
                                    />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={1}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.estado?true:false}
                                        label={t('label.state')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="estado"
                                        defaultValue={intialValues.estado}
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 2}}  
                                    />
                                    </FormControl>
                                </GridItem>
                            </GridContainer>
                            <Clearfix />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                    <div className={classes.textCenter}>
                        <Button  onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')} 
                            {loading && <div> ... {t('label.loading')} </div>}
                        </Button>
                    </div>
                </GridItem>
            </GridContainer>            
            </form>
        </div>
    );
}